import { IonImg, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import Toolbar from 'components/Toolbar';
import React from 'react';
import './Profile.css';

/* eslint-disable indent */

const Profile: React.FC = () => {
    return (
        <IonPage>
            <IonHeader>
                <Toolbar title="Meu Perfil" menuBtn={true} infoBtn={true} />
            </IonHeader>

            <IonContent className="ion-padding">
                <IonToolbar className="ion-text-center header-content">
                    <IonImg className="profile" src="assets/imgs/default.webp" />
                    <IonTitle>Nome do Usuário</IonTitle>
                </IonToolbar>

                <IonList>
                    <IonItem href="" disabled={true}>
                        <IonLabel>Ver contribuições</IonLabel>
                    </IonItem>
                    <IonItem href="" disabled={true}>
                        <IonLabel>Editar Perfil</IonLabel>
                    </IonItem>
                    <IonItem href="" disabled={true}>
                        <IonLabel>Ajuda e suporte</IonLabel>
                    </IonItem>
                    <IonItem href="" disabled={true}>
                        <IonLabel>Feedback</IonLabel>
                    </IonItem>

                    <IonItem href="" disabled={true}>
                        <IonLabel color="danger">Sair</IonLabel>
                    </IonItem>
                </IonList>

            </IonContent>
        </IonPage>
    );
};

export default Profile;
